import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaObservacaoInterna = (): TabelaColuna => ({
  Chave: 'observacaoInterna',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 130 }}>Observacao interna</div>
  )
})
